import React from 'react';
import { IconButton, IconButtonProps } from '@kontentino/ui';
import { Action, ActionProps, resolveLabel } from 'actions';

export type ActionIconButtonProps<TAction extends Action> =
  ActionProps<TAction> & IconButtonProps;

export const ActionIconButton = React.forwardRef(function <
  TAction extends Action,
>(
  {
    action,
    icon,
    actionParams,
    variant = 'secondary',
    size = 'small',
    ...props
  }: ActionIconButtonProps<TAction>,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <IconButton
      ref={ref}
      icon={icon ?? action.icon}
      aria-label={resolveLabel(action.label)}
      onClick={() => action.perform?.(actionParams)}
      variant={variant}
      size={size}
      {...props}
    />
  );
});
